import React from "react";

interface LoadingProps {
  data?: {};
}

const InvoiceLoader: React.FC<LoadingProps> = ({ data }) => {
  return (
    <div className="rounded-lg bg-white py-3  lg:py-6 w-full">
      <div className="flex justify-between items-center animate-pulse px-3 md:px-6">
        <span className="h-6 bg-[#E6EEF5] inline-block w-[30%] rounded-md"></span>
        <span className="h-6 bg-[#E6EEF5] inline-block w-[30%] rounded-md"></span>
      </div>
      <hr className="border border-[#EAECF0] w-full mt-3 mb-2" />

      <div className="mt-3 animate-pulse px-3 py-2 grid md:grid-cols-2 w-full grid-cols-1 gap-2">
        {[1, 2, 3, 4].map((i) => (
          <div className="animate-pulse w-full" key={i}>
            <span className="h-[100px] md:h-[80px] bg-[#E6EEF5] inline-block w-full rounded-md"></span>
          </div>
        ))}
      </div>

      <div className="flex justify-center items-center animate-pulse px-3 mt-5 mb-4 md:px-6">
        <span className="h-6 bg-[#E6EEF5] inline-block w-[30%] rounded-md"></span>
      </div>
    </div>
  );
};

export default InvoiceLoader;
